import script from "./showpet.vue?vue&type=script&setup=true&lang=js"
export * from "./showpet.vue?vue&type=script&setup=true&lang=js"

import "./showpet.vue?vue&type=style&index=0&id=7a99fae6&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a99fae6"]])

export default __exports__